(() => {
    if (!$) {
        return;
    }
    const nextScr = document.querySelector('.j-main-next-scr');
    const desktop = () => {
        $('html, body').animate({scrollTop: 0}, 'slow');
        document.querySelector('.j-complex-title').classList.remove('is-active');

        if (nextScr) {
            nextScr.classList.remove('is-active');
            nextScr.classList.add('is-closed');
        }
        document.querySelector('.j-header').classList.remove('is-open-img');
    };

    const mobile = () => {
        $('html, body').animate({scrollTop: 0}, 'slow');
    };

    const up = document.querySelector('.j-up-button');
    const breakpoint = window.matchMedia('(max-width: 960px)');
    const breakpointChecker = () => {
        if (up && !up.classList.contains('static')) {
            const check = () => {
                if ($('html, body').scrollTop() <= 200) {
                    up.style.display = 'none';
                } else {
                    up.style.display = 'flex';
                }
            };

            check();

            window.addEventListener('scroll', () => {
                check();
            });
        }

        if (breakpoint.matches && nextScr) {
            nextScr.classList.remove('is-active');
            nextScr.classList.remove('is-closed');
        }

        if (up) {
            up.removeEventListener('click', mobile);
            up.addEventListener('click', desktop);
        }
    };

    breakpoint.addListener(breakpointChecker);

    breakpointChecker();
})();
